import React from "react"
import { Portal } from "react-portal"

const PortalWrapper = ({ children }) => (
  <Portal node={document && document.querySelector(".app")}>{children}</Portal>
)

export default PortalWrapper
